<div class="flex h-fit flex-wrap gap-5" [ngClass]="(question.ResultClass.ResultClassType == ChecklistAnswerClassType.Canvas ||
 question.ResultClass.ResultClassType == ChecklistAnswerClassType.Html) ? 'items-start': 'items-center'"
     [class.w-full]="isMobileView">
    @switch (question.ResultClass.ResultClassType) {
        @case (ChecklistAnswerClassType.SingleChoice) {
            <bizz-singlechoice-control [isMobileView]="isMobileView" [(question)]="question" [isLocked]="isLocked()"
                                       (questionChange)="dispatchChange($event)" [isDarkTheme]="isDarkTheme"
                                       (resetButtonsOptions)="resetButtonsOptions.emit(true)"></bizz-singlechoice-control>

        }
        @case (ChecklistAnswerClassType.Text) {
            <kendo-textbox class="w-full lg:w-60" [readonly]="isLocked()" [value]="question.UserAnswer.Value ?? ''"
                           (valueChange)="setValue($event)"></kendo-textbox>
        }
        @case (ChecklistAnswerClassType.Numeric) {
            <div class="relative w-full lg:w-60">
                <kendo-numerictextbox class="select-none" [class.hide-input-text]="hasDisplayStyle && !inputHasFocus"
                                      [(value)]="question.UserAnswer.Value" [spinners]="false" [readonly]="isLocked()"
                                      (valueChange)="setNumericText($event); updateBackgroundColor($event)"
                                      (focus)="onFocus()" (blur)="onBlur()">
                </kendo-numerictextbox>
                @if (hasDisplayStyle && !inputHasFocus && question.UserAnswer && question.UserAnswer.Value !=
                undefined) {
                    <span class="color-preview text-white" [ngClass]="{'opacity-70': isLocked()}"
                          [ngStyle]="{ 'background-color': backgroundColor }">
            {{ question.UserAnswer.Value }}
        </span>
                }

            </div>
        }
        @case (ChecklistAnswerClassType.Canvas) {
            <bizz-canvas-control class="w-full xl:w-[600px]" [class.min-w-60]="isLocked()" [(ngModel)]="question.UserAnswer.Value"
                                 [defaultImage]="question.ResultClass.DefaultCanvasImage"
                                 (ngModelChange)="dispatchChange(question);"
                                 [configOverrides]="{  CanUseToolbar: true, CanDraw: true,
                                CanEditImage: true,
                                IsReadOnly: isLocked(),
                                CanvasHeight: 250,
                                FullWidth: true
                              }"></bizz-canvas-control>
        }
        @case (ChecklistAnswerClassType.Html) {
            <bizz-editor class="w-full xl:w-[600px]" [disabled]="isLocked()" [alwaysShowToolbar]="!isLocked()"
                         [value]="question.UserAnswer.Value ??''"
                         [minimumHeight]="isLocked() ? 45: 200"
                         (valueChange)="setValue($event)"></bizz-editor>
        }
        @default {
            ResultClassType: {{ question.ResultClass.ResultClassType }} not implemented!
        }
    }

    @if (question.ResultClass.ResultClassType != ChecklistAnswerClassType.SingleChoice) {
        <bizz-singlechoice-control [isNaNc]="true" [isMobileView]="isMobileView" [(question)]="question"
                                   [isLocked]="isLocked()" (questionChange)="dispatchChange($event)"
                                   (resetButtonsOptions)="resetButtonsOptions.emit(true)"></bizz-singlechoice-control>
    }

</div>